import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { CalendarDays, Sparkles, CreditCard } from 'lucide-react';

const StudentOverviewPage: React.FC = () => {
  return (
    <div className="p-4 sm:p-6 lg:p-8">
      <div className="mb-6">
        <h1 className="text-2xl sm:text-3xl font-bold text-foreground mb-2">Overview</h1>
        <p className="text-gray-400">Quick access to your learning and account modules.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Card className="">
          <CardHeader>
            <CardTitle className="text-foreground flex items-center gap-2">
              <CalendarDays className="w-5 h-5" />
              Bookings
            </CardTitle>
            <CardDescription>Manage upcoming lessons and scheduling.</CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-gray-300">Create, review, and cancel your bookings.</p>
          </CardContent>
        </Card>

        <Card className="">
          <CardHeader>
            <CardTitle className="text-foreground flex items-center gap-2">
              <Sparkles className="w-5 h-5" />
              AI Exercises
            </CardTitle>
            <CardDescription>Access guided AI-assisted practice content.</CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-gray-300">Track progress and continue your daily exercises.</p>
          </CardContent>
        </Card>

        <Card className="">
          <CardHeader>
            <CardTitle className="text-foreground flex items-center gap-2">
              <CreditCard className="w-5 h-5" />
              Billing
            </CardTitle>
            <CardDescription>Review subscriptions and payment history.</CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-gray-300 mb-2">
              Subscribe to lesson packages before booking. Manage credits and renewals here.
            </p>
            <Link
              to="/billing/subscriptions"
              className="text-sm text-violet-600 font-medium hover:underline"
            >
              Open subscriptions →
            </Link>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default StudentOverviewPage;

